import { createReducer } from "@reduxjs/toolkit";
import {
  GET_CURRENT_USER_FOLLOWERS_REQUEST,
  GET_CURRENT_USER_FOLLOWERS_SUCCESS,
  GET_CURRENT_USER_FOLLOWERS_FAIL,
  GET_OTHER_USER_FOLLOWERS_REQUEST,
  GET_OTHER_USER_FOLLOWERS_SUCCESS,
  GET_OTHER_USER_FOLLOWERS_FAIL
} from "../actions/followers";

const initialState = {
  isLoading: false,
  loading: false,
  currentUserFollowers: [],
  currentUserFollowing: [],
  otherUserFollowers: [],
  otherUserFollowing: [],
  error: null
};

export const followersReducer = createReducer(initialState, {
  [GET_CURRENT_USER_FOLLOWERS_REQUEST]: (state) => {
    state.isLoading = true;
    state.loading = true;
    state.error = null;
  },
  [GET_CURRENT_USER_FOLLOWERS_SUCCESS]: (state, action) => {
    state.isLoading = false;
    state.loading = false;
    state.error = null;
    state.currentUserFollowers = Array.isArray(action.payload.followers) ? action.payload.followers : [];
    state.currentUserFollowing = Array.isArray(action.payload.following) ? action.payload.following : [];
  },
  [GET_CURRENT_USER_FOLLOWERS_FAIL]: (state, action) => {
    state.isLoading = false;
    state.loading = false;
    state.error = action.payload;
  },
  [GET_OTHER_USER_FOLLOWERS_REQUEST]: (state) => {
    state.isLoading = true;
    state.loading = true;
    state.error = null;
  },
  [GET_OTHER_USER_FOLLOWERS_SUCCESS]: (state, action) => {
    state.isLoading = false;
    state.loading = false;
    state.error = null;
    state.otherUserFollowers = Array.isArray(action.payload.followers) ? action.payload.followers : [];
    state.otherUserFollowing = Array.isArray(action.payload.following) ? action.payload.following : [];
  },
  [GET_OTHER_USER_FOLLOWERS_FAIL]: (state, action) => {
    state.isLoading = false;
    state.loading = false;
    state.error = action.payload;
  }
});

export default followersReducer;

